import React from 'react';
import { Link } from 'react-router-dom';

const DocsNav = () => {
  const docs = [
    { id: 'firestore-mapping', title: 'Firestore Mapping' },
    { id: 'function-catalog', title: 'Function Catalog' },
    { id: 'variable-catalog', title: 'Variable Catalog' },
    { id: 'variable-usage-map', title: 'Variable Usage Map' },
  ];

  return (
    <div className="space-y-1">
      {docs.map((doc) => (
        <Link
          key={doc.id}
          to={`/docs/${doc.id}`}
          className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-50"
        >
          {doc.title}
        </Link>
      ))}
    </div>
  );
};

export default DocsNav;
